const currentUser = (state = {}, action) => {
    switch(action.type){
        case "SET_USER":
            return {
                ...state,
                loggedIn: true,
                user: {
                ...action.payload,
                loggedIn: true,
                designation: action.designation
                }
            }
        case "LOG_OUT":
            return {
                ...state,
                loggedIn: false,
                user: {
                    loggedIn: false,
                    designation: undefined
                },
            }
        default:
            return state
    }
}

export default currentUser;